import { ref } from 'vue'

const showError = ref(false)
const isTablePage = ref(false)

export function useInertiaError() {
  const show = (tableContext = false) => {
    isTablePage.value = tableContext
    showError.value = true
  }

  const hide = () => {
    showError.value = false
  }

  return { showError, isTablePage, show, hide }
}
